// extracted by mini-css-extract-plugin
module.exports = {"header":"WalletReports_header__2S6UL"};